import React from 'react';

import useRenderedLanguage from '../../capabilities/components/LanguageSelector/utils/useRenderedLanguage';
import { INTERNET_CONNECTIVITY_MESSAGES } from '../../utils/constants';
import { TRANSLATION_CLASS_NAMES } from '../../utils/element-ids';

import { type NotificationAlertProps } from './NotificationAlert';

export interface TitleInterceptorProps {
  title: string;
}
// This type combines the props for the HOC and the wrapped component
export type EnhancedComponentProps = TitleInterceptorProps &
  NotificationAlertProps;

const withTitleGuard = (
  WrappedComponent: React.ComponentType<NotificationAlertProps>,
) => {
  const EnhancedComponent: React.FC<EnhancedComponentProps> = (
    props,
  ) => {
    const { renderedLanguage } = useRenderedLanguage();
    let parsedTitle = props.title;

    const wrapperClassName =
      parsedTitle !==
      INTERNET_CONNECTIVITY_MESSAGES.NO_CONNECTION
        ? undefined
        : TRANSLATION_CLASS_NAMES.NO_TRANSLATION_CLASS_NAME;

    if (
      renderedLanguage === 'es' &&
      parsedTitle ===
        INTERNET_CONNECTIVITY_MESSAGES.NO_CONNECTION
    ) {
      parsedTitle = 'No hay conexión a Internet disponible.';
    }

    const modifiedProps = {
      ...props,
      title: parsedTitle,
      wrapperClassName,
    };

    return <WrappedComponent {...modifiedProps} />;
  };

  return EnhancedComponent;
};

export default withTitleGuard;
